import axios from "axios";
import { validateErrorResponse, ErrorResponse } from "./AxiosExtension";

//Get prefix token
const prefix = process.env.REACT_APP_PREFIX;

/**
 * Get cycles for scores
 * @returns {Array}
 */
export const GetLevelsForScore = async () => {
  const axiosOptions = {};
  axiosOptions.method = "get";
  axiosOptions.headers = {
    Authorization: localStorage.getItem(`cmToken${prefix}`),
  };
  axiosOptions.url = `${process.env.REACT_APP_REST_URL}/v2_1/school_cycles/levels_for_scores`;
  try {
    const response = await axios(axiosOptions);
    return response;
  } catch (error) {
    validateErrorResponse(error.response); // Call function to handle errors
    return ErrorResponse(error.response);
  }
};
/**
 * Get cycles for scores
 * @param {object} data
 * @returns {Array}
 */
export const GetScores = async (data) => {
  const axiosOptions = {};
  axiosOptions.method = "get";
  axiosOptions.headers = {
    Authorization: localStorage.getItem(`cmToken${prefix}`),
  };
  axiosOptions.url = `${process.env.REACT_APP_REST_URL}/v2/scores/report`;
  axiosOptions.params = data;
  try {
    const response = await axios(axiosOptions);
    return response;
  } catch (error) {
    validateErrorResponse(error.response); // Call function to handle errors
    return ErrorResponse(error.response);
  }
};

/**
 * Get cycles for scores
 * @param {object} data
 * @returns {Array}
 */
export const GetScoresReport = async (data = {}) => {
  const axiosOptions = {
    method: "get",
    headers: {
      Authorization: localStorage.getItem(`cmToken${prefix}`),
    },
    url: `${process.env.REACT_APP_REST_URL}/v2/scores/report_students`,
    params: data,
  };
  try {
    const response = await axios(axiosOptions);
    return response.data;
  } catch (error) {
    validateErrorResponse(error.response); // Call function to handle errors
    return ErrorResponse(error.response);
  }
};

/**
 * Get scores report PDF
 * @param {object} data
 * @returns {Blob}
 */
export const GetScoresReportPdf = async (data = {}) => {
  const axiosOptions = {
    method: "get",
    headers: {
      Authorization: localStorage.getItem(`cmToken${prefix}`),
    },
    url: `${process.env.REACT_APP_REST_URL}/v2/scores/report_students_pdf`,
    params: data,
    responseType: "blob",
  };
  try {
    const response = await axios(axiosOptions);
    return response;
  } catch (error) {
    validateErrorResponse(error.response);
    return ErrorResponse(error.response);
  }
};

/**
 * Get scores report XLSX
 * @param {object} data
 * @returns {Blob}
 */
export const GetScoresReportXlsx = async (data = {}) => {
  const axiosOptions = {
    method: "get",
    headers: {
      Authorization: localStorage.getItem(`cmToken${prefix}`),
    },
    url: `${process.env.REACT_APP_REST_URL}/v2/scores/report_students_excel`,
    params: data,
    responseType: "blob",
  };
  try {
    const response = await axios(axiosOptions);
    return response;
  } catch (error) {
    validateErrorResponse(error.response);
    return ErrorResponse(error.response);
  }
};
